<div class="formly-field-wrap">
  @if(!options.formState.disabled && !field.props['disabled'] && !field.props['readonly']) {
    <div class="same-line">
      <input 
        class="active-input number-input right" 
        [class.error]="formControl.invalid"
        type="{{field.props.type || 'number'}}"
        inputmode="numeric"
        [(ngModel)]="currencyValue"
        [formlyAttributes]="field"
        (ngModelChange)="onCurrencyValueChange($event)"
        [min]="field.props.min || null"
        [max]="field.props.max || null"
        placeholder="{{field.props.placeholder || field.props.label || '' | translate}}"
        autocomplete="true">
      <select 
        title="{{field.props.label! | translate}}"
        class="currency-select" 
        [(ngModel)]="currencyCode" 
        (ngModelChange)="onCurrencyCodeChange($event)">
        @for(code of currencyCodes; track $index) {
          @if(code === 'spacer') {
            <option disabled>__________________________________</option>
          } @else { 
            <option [value]="code">
              {{code}} - {{currencyNames[code]}}
            </option>
          }
        }
      </select>
    </div>
  } @else {
    <div [class]="'right ' + (options.formState.showCompactViewWhenDisabled ? 'compact-' : '') + 'disabled-text'">
      @if(currencyValue) {
        <!-- {{currencyValue || 0 | localeNumber:'decimal'}} {{currencyCode}} -->
        {{currencyValue | localeNumber:'currency':'1.2-2':currencyCode}}
      } @else {
        <span>-</span>
      }
    </div>

  }
  <ng-template #fieldComponent></ng-template>
</div>